export const COMMON_TAGS = {
  APP_NAME: 'app',
  STREAM_NAME: 'stream',
  NETWORK: 'network',
  FETCHED_FROM_SERVER: 'fetchedFromServer',
  BUILD_VER_MAP: 'BuildVerMap',
};

export const DEFAULT_OWNER_SCOPE = {
  [COMMON_TAGS.STREAM_NAME]: 'frontend',
  [COMMON_TAGS.APP_NAME]: 'ui-shell',
};

export const CONTEXT_NAMES = {
  COMPANY: 'company',
  OWNER: 'owner',
  SHELL: 'shell',
  APP_LEVEL_DATA: 'appLevelData',
  SESSION_REPLAY_META: 'sessionReplayMeta',
};

/**
 * ignoring filter apis for analytics page load traces
 *
 * filters are applied and updated very frequently in analytics
 * since analytics APIs take time to respond, user is more prone to open async filter for application while page is still loading
 * resulting in skewed metric of page load
 */
export const ANALYTICS_PAGE_LOAD_IGNORE_PATHS = [
  /\/api\/node\/filter/i,
  /\/api\/node\/widget_filters/i,
];
